import React from 'react';

const Servicessec = () => {
const services = [
  {
    id: 1,
    title: 'AI / Machine Learning Engineers',
    desc: 'Our AI and ML experts build smart solutions that automate workflows, analyze data, and help your business make better, faster decisions.',
    icon: 'fas fa-robot',
    href: '/ai-ml'
  },
  {
    id: 2,
    title: 'Dedicated Developers',
    desc: 'Hire skilled developers who work as part of your team to build secure, scalable, and high-performing web or mobile applications.',
    icon: 'fas fa-code',
    href: '/dedicated-developer'
  },
  {
    id: 3,
    title: 'DevOps & Cloud Engineers',
    desc: 'We optimize your cloud setup and automate deployments to improve performance, reduce downtime, and ensure smooth development operations.',
    icon: 'fas fa-cloud',
    href: '/devops-cloud'
  },
  {
    id: 4,
    title: 'QA & Testing Engineers',
    desc: 'Our QA team performs detailed manual and automated testing to find issues early, ensure quality, and deliver reliable software every time.',
    icon: 'fas fa-vial',
    href: '/qa-testing'
  },
  {
    id: 5,
    title: 'Project Management',
    desc: 'Certified project managers use agile methods to plan, track, and deliver your projects on time with clear communication and coordination.',
    icon: 'fas fa-tasks',
    href: '/project-management'
  }
];


  const avatarStyle = {
    width: 90,
    height: 90,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 34,
    background: 'var(--bs-primary-bg-subtle, rgba(0,123,255,0.08))',
    color: 'var(--bs-primary, #0066FF)',
    overflow: 'hidden'
  };

  const titleStyle = {
    color: 'var(--bs-dark, #1a2a33)',
    fontSize: '1.125rem',
    fontWeight: 700,
    marginTop: 12
  };

  const descStyle = {
    color: 'var(--bs-body-color, #4A5568)',
    lineHeight: 1.75,
    marginTop: 8,
    fontSize: '0.95rem'
    ,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };


  return (
    <section className="insurance-roles-section" style={{padding: '60px 0', background: '#fff'}}>
      {/* use container-fluid so section can span full width and avoid unwanted right-side whitespace */}
  <div className="container-fluid" style={{padding: '0 120px'}}>
        <h2 className="insurance-roles-title" style={{textAlign: 'center', fontFamily: 'var(--bs-heading-font-family)', fontSize: '2rem', color: 'var(--bs-dark)', fontWeight: 700, marginBottom: 10}}>What We Offer</h2>
        <p className="insurance-roles-subtitle" style={{textAlign: 'center', color: 'var(--bs-body-color)', marginBottom: 40}}>Our Software & AI Services connect you with top-tier remote professionals, each specializing in a critical area of modern technology. Explore our offerings below to see how we can help you innovate, automate, and accelerate your business growth.</p>

        <div className="insurance-roles-list row g-0" style={{gap: 20}}>
          {services.map((s, idx) => (
            <div key={s.id} className="insurance-role-item col-12" style={{marginBottom: 0}}>
              <a href={s.href} className="text-decoration-none d-flex w-100" style={{gap: 18, alignItems: 'center', padding: '18px 0'}} aria-label={`Open ${s.title}`}>
                <div className="insurance-role-avatar" style={avatarStyle} aria-hidden>
                  <i className={s.icon} aria-hidden style={{fontSize: 28}}></i>
                </div>

                {/* reduce title column to encourage wrapping into two lines */}
                <div style={{flex: '0 0 320px', minWidth: 0}}>
                  <div className="insurance-role-title" style={{...titleStyle, fontSize: '1.25rem', lineHeight: '1.1', overflowWrap: 'break-word', wordBreak: 'break-word'}}>{s.title}</div>
                </div>

                <div style={{flex: '1 1 auto', padding: '0 20px'}}>
                  <div className="insurance-role-about" style={descStyle}>{s.desc}</div>
                </div>

                <div style={{flex: '0 0 48px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <span style={{border: '2px solid var(--bs-primary, #0066FF)', borderRadius: '50%', width: 36, height: 36, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: 'var(--bs-primary, #0066FF)'}} aria-hidden>
                    <i className="fas fa-arrow-right" style={{fontSize: 12}}></i>
                  </span>
                </div>
              </a>

              {/* separator line */}
              {idx < services.length - 1 && (
                <hr style={{border: 0, borderTop: '1px solid #e8e8e8', margin: 0}} />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Servicessec;